import React, { useEffect, useState, createElement } from 'react';
import { XIcon } from 'lucide-react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Buyers } from './pages/Buyers';
import { Owners } from './pages/Owners';
import { OurTeam } from './pages/OurTeam';
import { SampleDealBrief } from './pages/SampleDealBrief';
import { Exit } from './pages/Exit';
import { ThankYou } from './pages/ThankYou';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppContent({
  onBuyerContactOpen,
  onOwnerContactOpen
}: {
  onBuyerContactOpen: () => void;
  onOwnerContactOpen: () => void;
}) {
  const location = useLocation();
  const isExitPage = location.pathname === '/exit';
  const isStandalonePage = isExitPage || location.pathname === '/thankyou';
  return <>
      <ScrollToTop data-id="element-0" />
      {!isStandalonePage && <Nav onBuyerContactOpen={onBuyerContactOpen} data-id="element-1" />}
      <Routes data-id="element-2">
        <Route path="/" element={<Home onBuyerContactOpen={onBuyerContactOpen} onOwnerContactOpen={onOwnerContactOpen} data-id="element-4" />} data-id="element-3" />
        <Route path="/buyers" element={<Buyers onBuyerContactOpen={onBuyerContactOpen} data-id="element-6" />} data-id="element-5" />
        <Route path="/owners" element={<Owners onOwnerContactOpen={onOwnerContactOpen} data-id="element-8" />} data-id="element-7" />
        <Route path="/our-team" element={<OurTeam onContactOpen={onBuyerContactOpen} data-id="element-10" />} data-id="element-9" />
        <Route path="/sample-deal-brief" element={<SampleDealBrief onBuyerContactOpen={onBuyerContactOpen} data-id="element-12" />} data-id="element-11" />
        <Route path="/exit" element={<Exit onOwnerContactOpen={onOwnerContactOpen} data-id="element-14" />} data-id="element-13" />
        <Route path="/thankyou" element={<ThankYou data-id="element-16" />} data-id="element-15" />
      </Routes>
      {!isStandalonePage && <Footer onBuyerContactOpen={onBuyerContactOpen} onOwnerContactOpen={onOwnerContactOpen} data-id="element-17" />}
    </>;
}
export function App() {
  const [buyerModalOpen, setBuyerModalOpen] = useState(false);
  const [ownerModalOpen, setOwnerModalOpen] = useState(false);
  // Load Google Tag Manager globally
  useEffect(() => {
    const GTM_ID = 'GTM-PMGCCDQ5';
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    // Inject GTM script
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(gtmScript);
    // Inject GTM noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    console.log(`✅ Google Tag Manager (${GTM_ID}) loaded and present on page.`);
    return () => {
      if (document.head.contains(gtmScript)) document.head.removeChild(gtmScript);
      if (document.body.contains(noscript)) document.body.removeChild(noscript);
    };
  }, []);
  // Load Typeform script once globally
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);
  // Lock body scroll when any modal open
  useEffect(() => {
    document.body.style.overflow = buyerModalOpen || ownerModalOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [buyerModalOpen, ownerModalOpen]);
  const renderModal = (isOpen: boolean, onClose: () => void, tfId: string) => <div className={`fixed inset-0 z-[200] flex items-center justify-center p-4 transition-all duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} style={{
    background: 'rgba(0,0,0,0.85)',
    backdropFilter: 'blur(4px)'
  }} onClick={onClose} data-id="element-18">
      <div className={`relative w-full max-w-2xl bg-[#111] border border-white/10 rounded-xl overflow-hidden shadow-2xl transition-all duration-300 ${isOpen ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'}`} style={{
      height: '82vh'
    }} onClick={e => e.stopPropagation()} data-id="element-19">
        <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" aria-label="Close" data-id="element-20">
          <XIcon className="w-5 h-5" data-id="element-21" />
        </button>
        <div data-tf-live={tfId} style={{
        width: '100%',
        height: '100%'
      }} data-id="element-22" />
      </div>
    </div>;
  return <Router data-id="element-23">
      {/* Buyer Typeform Modal */}
      {renderModal(buyerModalOpen, () => setBuyerModalOpen(false), '01K1GHCCVPBYVBFJRSZ3TBJPAX')}

      {/* Owner/Seller Typeform Modal */}
      {renderModal(ownerModalOpen, () => setOwnerModalOpen(false), '01KHVP1TDTWKZ40CHGKF8XRCCT')}

      <AppContent onBuyerContactOpen={() => setBuyerModalOpen(true)} onOwnerContactOpen={() => setOwnerModalOpen(true)} data-id="element-24" />
    </Router>;
}